import t from "../../../utils/validators/link.js";
const l = {
  /**
   * Card eyebrow, optional
   */
  eyebrow: {
    type: String,
    default: ""
  },
  /**
   * Card icon, optional
   */
  icon: {
    type: Object,
    default: null
  },
  /**
   * Card tags, optional
   */
  tags: {
    type: Array,
    default: () => []
  },
  /**
   * Tag(s), color, if any tag is present. Defaults to green.
   * For more info on the available tag colors, see the DsTag component in the design system.
   */
  tagColor: {
    type: String,
    default: "green"
  },
  /**
   * Card title, optional
   */
  title: {
    type: String,
    default: ""
  },
  /**
   * Card text, optional
   */
  text: {
    type: String,
    default: ""
  },
  /**
   * Card subtitle, optional.
   * renders the card subtitle text.
   */
  subtitle: {
    type: String,
    default: ""
  },
  /**
   * Card subtext, optional.
   * renders a small text below the main text.
   */
  subtext: {
    type: String,
    default: ""
  },
  /**
   * Card link, optional.
   */
  link: {
    type: Object,
    default: null,
    validator: (e) => t(e)
  },
  /**
   * Card image aspect ratio, optional.
   * sets aspect ratio for image
   */
  aspectRatio: {
    type: String,
    default: null
  },
  /**
   * Card title size, optional.
   * renders the title in a bigger font size.
   */
  withTitleSizeLarge: {
    type: Boolean,
    default: !1
  },
  /**
   * Card title size, optional.
   * renders the title in a smaller font size.
   */
  withTitleSizeSmall: {
    type: Boolean,
    default: !1
  },
  /**
   * Card subtitle size, optional.
   * renders the subtitle in a bigger font size.
   */
  withSubtitleSizeLarge: {
    type: Boolean,
    default: !1
  },
  /**
   * Card shadow, optional.
   * renders a shadow behind the image if the card is not displayed in the contained mode.
   */
  withShadow: {
    type: Boolean,
    default: !1
  },
  /**
   * Card content padding, optional.
   */
  contained: {
    type: Boolean,
    default: !1
  },
  /**
   * Card content padding size, optional and only rendered when contained is set to true.
   */
  withPaddingLarge: {
    type: Boolean,
    default: !1
  },
  /**
   * Card content alignment, if set to true aligns all the content to the center.
   */
  centerAligned: {
    type: Boolean,
    default: !1
  },
  /**
   * Resizes text to medium.
   */
  withTextSizeMedium: {
    type: Boolean,
    default: !1
  }
};
export {
  l as default
};
